import clsx from 'clsx';
import React from 'react';
import { Text } from '../Text';
import { VisuallyHidden } from '../VisuallyHidden';
export function TableCaption(props) {
    const { children, className, hidden, ...rest } = props;
    if (hidden) {
        return React.createElement(VisuallyHidden, { elementType: "caption" }, children);
    }
    return (React.createElement(Text, { elementType: "caption", ...rest, className: clsx('mollie-ui-table-caption', className) }, children));
}
TableCaption.displayName = 'Table.Caption';
//# sourceMappingURL=TableCaption.js.map